import React, { useCallback, useEffect, useState } from 'react';
import { Card, Input, InputNumber, Space, Table, Tag } from 'antd';
import PageHeader from '../../components/business/PageHeader';
import RequestState from '../../components/business/RequestState';
import { PageResult } from '../../models/v2';
import { V2ApiError, v2Api } from '../../services/v2';
import { asV2Error, formatDateTime } from '../../utils/v2';

const emptyPage: PageResult<any> = { items: [], pageNo: 1, pageSize: 20, total: 0 };
const AuditEventsPage = () => {
    const [data, setData] = useState(emptyPage);
    const [filters, setFilters] = useState<any>({ pageNo: 1, pageSize: 20 });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<V2ApiError | null>(null);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            setData(await v2Api.auditEvents(filters));
        } catch (e) {
            setError(asV2Error(e));
        } finally {
            setLoading(false);
        }
    }, [filters]);
    useEffect(() => {
        load();
    }, [load]);
    const columns = [
        { title: '时间', dataIndex: 'occurredAt', width: 170, render: formatDateTime },
        {
            title: '操作',
            dataIndex: 'actionCode',
            width: 210,
            render: (v: string) => <Tag color="blue">{v}</Tag>,
        },
        {
            title: '业务对象',
            key: 'object',
            width: 170,
            render: (_: any, row: any) => `${row.objectType} #${row.objectId}`,
        },
        { title: '操作人', dataIndex: 'actorId', width: 90 },
        { title: '原因', dataIndex: 'reason', render: (v: string) => v || '—' },
        { title: '结果', dataIndex: 'resultCode', width: 110 },
        { title: '请求编号', dataIndex: 'requestId', width: 220, ellipsis: true },
    ];
    return (
        <div className="v2-page">
            <PageHeader
                eyebrow="系统管理 · 可追溯性"
                title="审计日志"
                description="只展示最小变更摘要和业务原因，不复制联系方式、凭证、Token 或其他敏感明文。"
            />
            <Card className="v2-filter-card">
                <Space className="v2-wrap-space">
                    <Input
                        placeholder="对象类型，如 PROJECT"
                        onPressEnter={(e) =>
                            setFilters({
                                ...filters,
                                objectType: (e.target as HTMLInputElement).value,
                                pageNo: 1,
                            })
                        }
                    />
                    <InputNumber
                        min={1}
                        placeholder="对象 ID"
                        onChange={(objectId) => setFilters({ ...filters, objectId, pageNo: 1 })}
                    />
                    <Input
                        placeholder="操作编码"
                        onPressEnter={(e) =>
                            setFilters({
                                ...filters,
                                actionCode: (e.target as HTMLInputElement).value,
                                pageNo: 1,
                            })
                        }
                    />
                </Space>
            </Card>
            <Card className="v2-panel">
                <RequestState
                    loading={loading}
                    error={error}
                    empty={!data.items.length}
                    onRetry={load}
                >
                    <Table
                        rowKey="eventId"
                        columns={columns}
                        dataSource={data.items}
                        scroll={{ x: 1150 }}
                        pagination={{
                            current: data.pageNo,
                            pageSize: data.pageSize,
                            total: data.total,
                            showSizeChanger: true,
                            onChange: (pageNo, pageSize) =>
                                setFilters({ ...filters, pageNo, pageSize }),
                        }}
                    />
                </RequestState>
            </Card>
        </div>
    );
};
export default AuditEventsPage;
